// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"0aec35dc","537":"f2d7e57f","554":"f3447473","663":"e08cb866","824":"881ef4bf","943":"2ae7ae63"}[chunkId] + ".chunk.js";
};